import SurvivorInfoContainer from './SurvivorInfoContainer';
export default SurvivorInfoContainer;